export const GET_LIST_INFO_USERS = 'GET_LIST_INFO_USERS'
export const GET_LIST_INFO_USERS_ERR = 'GET_LIST_INFO_USERS_ERR'